<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Геймификация сканирования карт</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активна
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    :checked.sync="settings.enabled"
                                    color="success"
                                    shape="pill"
                                    variant="opposite"/>
                            </CCol>
                        </CRow>

                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Родительский промокод
                            </CCol>
                            <CCol sm="9">
                                <CSelect
                                    :value.sync="settings.parent_promocode_id"
                                    :options="promocodeOptions"
                                    placeholder="Выберите промокод"/>
                                <CLink
                                    v-if="settings.parent_promocode_id"
                                    class="d-inline-block mt-2"
                                    :to="{ path: `/promocodes/${settings.parent_promocode_id}` }">
                                    Открыть промокод
                                </CLink>
                            </CCol>
                        </CRow>

                        <CInput
                            v-model.number="settings.scan_period_hours"
                            type="number"
                            label="Период между засчитанными сканированиями, часов"/>
                        <CInput
                            v-model.number="settings.scans_to_reward"
                            type="number"
                            label="Сканирований до промокода"/>
                        <CInput
                            v-model.number="settings.streak_expire_days"
                            type="number"
                            label="Сброс стрика без сканирования, дней"/>
                        <CInput
                            v-model.number="settings.reward_term_days"
                            type="number"
                            label="Срок действия выданного промокода, дней"/>
                        <CInput
                            v-model.number="settings.reward_code_length"
                            type="number"
                            label="Длина кода промокода"/>
                        <CInput
                            v-model="settings.title"
                            label="Заголовок блока"/>
                        <CInput
                            v-model="settings.description"
                            label="Описание"/>
                        <CInput
                            v-model="settings.terms_url"
                            label="Ссылка на подробные условия"/>

                        <h5 class="mt-4 mb-3">Push: один скан до промокода</h5>
                        <CInput
                            v-model="settings.push_2_scans_title"
                            label="Заголовок"/>
                        <CInput
                            v-model="settings.push_2_scans_text"
                            label="Текст"/>

                        <h5 class="mt-4 mb-3">Push: стрик сгорает, прогресс не финальный</h5>
                        <CInput
                            v-model="settings.push_expire_1_scan_title"
                            label="Заголовок"/>
                        <CInput
                            v-model="settings.push_expire_1_scan_text"
                            label="Текст"/>

                        <h5 class="mt-4 mb-3">Push: стрик сгорает, один скан до промокода</h5>
                        <CInput
                            v-model="settings.push_expire_2_scans_title"
                            label="Заголовок"/>
                        <CInput
                            v-model="settings.push_expire_2_scans_text"
                            label="Текст"/>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">
                        Сохранить
                    </CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">
                        Отмена
                    </CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    const DEFAULT_SETTINGS = {
        enabled: false,
        parent_promocode_id: null,
        scan_period_hours: 24,
        scans_to_reward: 3,
        streak_expire_days: 5,
        reward_term_days: 5,
        reward_code_length: 8,
        title: '',
        description: '',
        terms_url: '',
        push_2_scans_title: '',
        push_2_scans_text: '',
        push_expire_1_scan_title: '',
        push_expire_1_scan_text: '',
        push_expire_2_scans_title: '',
        push_expire_2_scans_text: '',
    };

    export default {
        name: 'CardScanGamificationSettings',

        data() {
            return {
                settings: { ...DEFAULT_SETTINGS },
                promocodes: [],
            };
        },

        computed: {
            promocodeOptions() {
                const options = [{ value: '', label: 'Не выбран' }];
                this.promocodes.forEach(promocode => {
                    options.push({
                        value: promocode.id,
                        label: `${promocode.code} #${promocode.id}`
                    });
                });
                return options;
            },
        },

        async mounted() {
            await Promise.all([
                this.loadSettings(),
                this.loadPromocodes()
            ]);
        },

        methods: {
            async loadSettings() {
                const { data } = await Vue.axios.get('/card-scan-gamification');
                this.settings = { ...DEFAULT_SETTINGS, ...data };
                this.settings.parent_promocode_id = this.settings.parent_promocode_id || '';
            },
            async loadPromocodes() {
                const { data } = await Vue.axios.get('/promocodes', {
                    params: { page: 1, pageSize: 500 }
                });
                this.promocodes = data?.results || [];
            },
            async save() {
                try {
                    const data = { ...this.settings };
                    const parentPromocodeId = parseInt(data.parent_promocode_id, 10);
                    data.parent_promocode_id = Number.isFinite(parentPromocodeId) && parentPromocodeId > 0 ? parentPromocodeId : null;
                    await Vue.axios.put('/card-scan-gamification', data);
                    this.$root.$emit('showSuccess', 'Настройки сохранены.');
                    await this.loadSettings();
                } catch (e) {
                    this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка сохранения.');
                    console.log(e);
                }
            },
            goBack() {
                this.$router.push({ path: '/dashboard' });
            },
        },
    };
</script>
